import { AxiosRequestConfig } from 'axios';
import instance from 'api';
import { IRealEstateReport } from './interfaces';

export const getRealEstateReports = (realEstateGuid: string, config?: AxiosRequestConfig) => {
  return instance()
    .get<{ list: IRealEstateReport[]; totalCount: number }>(`/realEstateReport/${realEstateGuid}/list`, config)
    .then((response) => response.data);
};

export const publishRealEstateReport = (reportId: number) => {
  return instance()
    .post(`/realEstateReport/${reportId}/publish`)
    .then((response) => response.data);
};

export const draftRealEstateReport = (reportId: number) => {
  return instance()
    .post(`/realEstateReport/${reportId}/draft`)
    .then((response) => response.data);
};

export const replaceRealEstateReportFile = (reportId: number, file: string) => {
  return instance()
    .post(`/realEstateReport/${reportId}/replaceFile`, { file })
    .then((response) => response.data);
};
